let layoutRequestInProgress = null;

export function sameLayoutRequestIsInProgress(initialModule, finalModule) {
  return (
    layoutRequestInProgress &&
    layoutRequestInProgress.initialModule === initialModule &&
    layoutRequestInProgress.finalModule === finalModule
  );
}

export function setLayoutRequestInProgress(initialModule, finalModule) {
  layoutRequestInProgress = {
    initialModule,
    finalModule
  };
}

export function unsetLayoutRequestInProgress() {
  layoutRequestInProgress = null;
}
